// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1K0Pr","rootSuccess":"CompleteLink_rootSuccess__3e1pH","rootFailure":"CompleteLink_rootFailure__5JqYD","isDisabled":"CompleteLink_isDisabled__2obJc"};